(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[773],{

/***/ 53969:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/[slug]",
      function () {
        return __webpack_require__(51822);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-google-maps/lib/index.js
var lib = __webpack_require__(33458);
;// CONCATENATED MODULE: ./src/app/components/maps/GoogleMapComp.tsx




var GoogleMapComp = function(props) {
    var extMapProps = props.mapProps || {}, markerPosition = {
        lat: props.coordinate.latitude,
        lng: props.coordinate.longitude
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* GoogleMap */.b6, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        defaultZoom: 12,
        defaultCenter: markerPosition
    }, extMapProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Marker */.Jx, {
            position: markerPosition
        })
    }));
};
/* harmony default export */ var maps_GoogleMapComp = ((0,lib/* withScriptjs */.WS)((0,lib/* withGoogleMap */.OI)(GoogleMapComp)));

// EXTERNAL MODULE: ./src/app/components/experts/SimpleExpertLinkCard.tsx
var SimpleExpertLinkCard = __webpack_require__(18270);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
;// CONCATENATED MODULE: ./pages/locations/[slug].tsx











var LocationDetailPage = function(props) {
    var ref, ref1, ref2;
    var geolocation = props.geolocation, pageName = geolocation.name, ssrMetaDescription = (0,helpers/* sliceMetaDescription */.rJ)(geolocation.content.text, 210), googleMapUrl = "https://maps.googleapis.com/maps/api/js?v=3&key=".concat(constants/* GMAP_KEY */.ui);
    var officeName = [
        geolocation.name,
        "Location"
    ].join(" "), addressCityState = [
        geolocation === null || geolocation === void 0 ? void 0 : geolocation.city,
        [
            geolocation === null || geolocation === void 0 ? void 0 : geolocation.state,
            geolocation === null || geolocation === void 0 ? void 0 : geolocation.zip
        ].filter(Boolean).join(" ")
    ].filter(Boolean).join(", "), carouselImages = geolocation.carousels, officeHours = geolocation.operatingHours;
    /**
   * Meta contents
   */ var metaTitle = constants/* META_TITLE */.k5 || "", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = constants/* META_URL */.f1 || "", metaOgImg = constants/* META_URL */.f1 + "/logo.png", metaTwitterImg = constants/* META_URL */.f1 + "/logo.png";
    if (geolocation) {
        var ref3, ref4;
        metaTitle = "".concat(officeName, " | Heritage Counseling");
        metaDescription = ssrMetaDescription || metaDescription;
        metaUrl = "".concat(constants/* META_URL */.f1, "/locations/").concat(geolocation.slug);
        metaOgImg = ((ref3 = geolocation.image) === null || ref3 === void 0 ? void 0 : ref3.url) || metaOgImg;
        metaTwitterImg = ((ref4 = geolocation.image) === null || ref4 === void 0 ? void 0 : ref4.url) || metaTwitterImg;
    }
    // Override metas using pageMeta
    var pageMeta = (geolocation === null || geolocation === void 0 ? void 0 : geolocation.meta) || {};
    if (Object.keys(pageMeta).length > 0) {
        var ref5, ref6;
        metaTitle = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.title) || metaTitle;
        metaDescription = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.description) || metaDescription;
        metaOgImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref5 = pageMeta.ogImage) === null || ref5 === void 0 ? void 0 : ref5.url) || metaOgImg;
        metaTwitterImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref6 = pageMeta.twitterImage) === null || ref6 === void 0 ? void 0 : ref6.url) || metaTwitterImg;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: pageName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaOgImg
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaTwitterImg
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    (geolocation === null || geolocation === void 0 ? void 0 : geolocation.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(geolocation.schema)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "location-detail-page",
                "data-testid": "location-detail-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "mb-5 mb-lg-10",
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/locations",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "link-back",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-angle-left"
                                    }),
                                    "Back to Locations"
                                ]
                            })
                        })
                    }),
                    geolocation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "horizontal-hid-layout-hoc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(maps_GoogleMapComp, {
                                        coordinate: geolocation.coordinate,
                                        googleMapURL: googleMapUrl,
                                        loadingElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                height: "100%"
                                            }
                                        }),
                                        containerElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "map-container"
                                        }),
                                        mapElement: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "map"
                                        }),
                                        mapProps: {
                                            defaultOptions: {
                                                disableDefaultUI: true
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: officeName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                                children: [
                                                    geolocation.address.map(function(address, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "address-line",
                                                                children: address
                                                            })
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "address-city-state",
                                                            children: addressCityState
                                                        })
                                                    })
                                                ]
                                            }),
                                            ((ref = geolocation.contact) === null || ref === void 0 ? void 0 : ref.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                title: "Phone",
                                                "aria-label": "Phone",
                                                href: "tel:".concat(geolocation.contact.phone),
                                                className: "btn btn-external btn-main px-5 py-3",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa fa-phone-alt mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Call for more information"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!carouselImages.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                navigation: true,
                                loop: true,
                                modules: [
                                    swiper_esm/* Navigation */.W_
                                ],
                                className: "mySwiper",
                                children: carouselImages.map(function(carouselItem, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: carouselItem.photo.url,
                                            alt: carouselItem.caption,
                                            width: carouselItem.photo.width,
                                            height: carouselItem.photo.height
                                        })
                                    }, idx);
                                })
                            }),
                            !!officeHours.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "business-hours",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "title",
                                        children: "Business Hours"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "list-group list-group-flush business-hours-list",
                                        children: officeHours.map(function(officeHour, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "list-group-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: officeHour.dayName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: officeHour.operatingHour
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            !!(geolocation === null || geolocation === void 0 ? void 0 : (ref1 = geolocation.content) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cms-content",
                                dangerouslySetInnerHTML: {
                                    __html: geolocation.content.html
                                }
                            }),
                            !!((ref2 = geolocation.experts) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "experts",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "title",
                                        children: "Experts"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "experts-wrapper",
                                        children: geolocation.experts.map(function(expert, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleExpertLinkCard/* default */.Z, {
                                                expert: expert
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: "No locations found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "mt-5 mt-lg-10",
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/locations",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "link-back",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-angle-left"
                                    }),
                                    "Back to Locations"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (LocationDetailPage);


/***/ }),

/***/ 18270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);




var SimpleExpertLinkCard = function(props) {
    var ref, ref1, ref2;
    var expert = props.expert, isAmp = props.isAmp, className = props.className, classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()("simple-expert-link-card", className), displayName = [
        expert.firstName || "",
        expert.lastName || ""
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/teams/".concat(expert.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: classes,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "img-container",
                    children: isAmp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("amp-img", {
                        alt: expert.slug,
                        src: (ref = expert.image) === null || ref === void 0 ? void 0 : ref.src,
                        width: 150,
                        height: 150,
                        layout: "responsive"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "avatar",
                        src: ((ref1 = expert.image) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                        loading: "lazy",
                        width: 300,
                        height: 311,
                        alt: expert.slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "display-name",
                    children: [
                        displayName,
                        ((ref2 = expert.credentials) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "d-none d-md-inline",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: ",\xa0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "credentials",
                                    children: expert.credentials.join(", ")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                }),
                expert.position ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "position",
                    children: expert.position
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleExpertLinkCard);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [719,458,774,888,179], function() { return __webpack_exec__(53969); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);